import React from 'react';
import Loading from '../../../shared/loading';
import Validator from '../../../shared/validator';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import mutate from '../../../shared/mutate';
import { MINIMUM_PASSWORD_LENGTH } from '../../../shared/consts';
import { setPassword } from '../../../services/profiles/personal-details-service';

export default class PasswordChangeModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.validator = new Validator({
      passwordRequired: s => !!s.password,
      passwordLength: s => !s.password || s.password.length >= MINIMUM_PASSWORD_LENGTH,
      passwordContainsDigit: s => !s.password || /[0-9]/.test(s.password),
      passwordsMustMatch: s => s.password === s.verifyPassword,
    });
    this.state = {
      password: '',
      // eslint-disable-next-line react/no-unused-state
      verifyPassword: '',
      validations: this.validator.getValidations(),
    };
  }

  componentDidMount() {
    const self = this;

    this.$modal.click(function onClick(e) {
      if (e.target === this) self.dismiss();
    });
  }

  handlePasswordChange(e) {
    const password = e.target.value;

    this.setState(oldState => mutate(oldState, s => {
      s.password = password;
      s.validations.passwordRequiredValid = this.validator.validatePasswordRequired(s);
      s.validations.passwordLengthValid = this.validator.validatePasswordLength(s);
      s.validations.passwordContainsDigitValid = this.validator.validatePasswordContainsDigit(s);
      s.validations.passwordsMustMatchValid = this.validator.validatePasswordsMustMatch(s);
    }));
  }

  handleVerifyPasswordChange(e) {
    const verifyPassword = e.target.value;

    this.setState(oldState => mutate(oldState, state => {
      state.verifyPassword = verifyPassword;
      state.validations.passwordsMustMatchValid = this.validator.validatePasswordsMustMatch(state);
    }));
  }

  save(evt) {
    evt && evt.preventDefault && evt.preventDefault();

    this.setState(state => ({
      validations: this.validator.validateForm(state),
    }), () => {
      if (!this.validator.formValid) return;

      this.loading.start();
      setPassword(this.state.password)
        .then(() => this.dismiss())
        .catch(e => defaultOnErrorHandler(e, 'Error changing password'))
        .finally(() => this.loading.stop());
    });
  }

  present(e) {
    e && e.preventDefault && e.preventDefault();

    this.validator.resetValidation();
    this.setState({
      password: '',
      // eslint-disable-next-line react/no-unused-state
      verifyPassword: '',
      validations: this.validator.getValidations(),
    });
    this.$overlay.fadeIn();
    this.$modal.fadeIn();
    this.$passwordInput.focus();
  }

  dismiss(e) {
    e && e.preventDefault && e.preventDefault();
    this.$overlay.fadeOut();
    this.$modal.fadeOut();
  }

  render() {
    const { validations: v } = this.state;
    const passwordValid = v.passwordRequiredValid && v.passwordLengthValid
      && v.passwordContainsDigitValid;

    return (
      <div>
        <div
          role="region"
          className="modal-overlay"
          ref={el => (this.$overlay = $(el))}
          onClick={() => this.dismiss()}
        />
        <div className="modal" tabIndex="-1" role="dialog" ref={el => (this.$modal = $(el))}>
          <article>
            <header>
              <h4>Change password</h4>
            </header>
            <Loading ref={c => (this.loading = c)}>
              <section>
                <p className={`form-group ${passwordValid ? '' : 'has-error'}`}>
                  <label htmlFor="password">
                    Password:
                    <input
                      id="password"
                      type="password"
                      placeholder="Password"
                      ref={el => (this.$passwordInput = $(el))}
                      onChange={e => this.handlePasswordChange(e)}
                    />
                    {v.passwordRequiredValid || <span className="help-block">Password is required</span>}
                    {v.passwordLengthValid || (
                      <span className="help-block">
                        {`Password must be at least ${MINIMUM_PASSWORD_LENGTH} characters`}
                      </span>
                    )}
                    {v.passwordContainsDigitValid || (
                      <span className="help-block">Password must include at least one digit</span>
                    )}
                  </label>
                </p>
                <p className={`form-group ${v.passwordsMustMatchValid ? '' : 'has-error'}`}>
                  <label htmlFor="repeat-password">
                    Verify password:
                    <input
                      id="repeat-password"
                      type="password"
                      placeholder="Verify password"
                      onChange={e => this.handleVerifyPasswordChange(e)}
                    />
                    {v.passwordsMustMatchValid || (
                      <span className="help-block">Passwords must match</span>
                    )}
                  </label>
                </p>
              </section>
              <footer>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={e => this.dismiss(e)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={e => this.save(e)}
                >
                  Change password
                </button>
              </footer>
            </Loading>
          </article>
        </div>
      </div>
    );
  }
}
